export default "__VITE_ASSET__DsSSEjSK__"